module.exports = __webpack_public_path__ + "static/img/case-glj-page-bg-06.cf52714.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/glj/case-glj-page-bg-06.jpg
// module id = TS95
// module chunks = 1